import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CursosService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getCursos() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/cursos')
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCurso(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/cursos/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCurso(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/cursos', {
				curso_nome: data.curso_nome,
				curso_validade: data.curso_validade
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCurso(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/cursos/' + data.curso_id, {
				curso_nome: data.curso_nome,
				curso_validade: data.curso_validade
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCurso(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/cursos/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
